var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home-page"},[_c('router-view'),_c('HeadBar'),_c('el-divider'),_c('div',{staticClass:"layout"},[_c('StaffOverview'),_c('LineNotifyQuota'),_c('ShopUsageSummary')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }